import { z } from 'zod';
import { CommentKindSchema, CommentStatusSchema } from './enums.js';
import { UserSummarySchema } from './auth.js';

export const CommentSchema = z.object({
  id: z.string(),
  orgId: z.string(),
  responseId: z.string(),
  responseVersion: z.number().int().nullable(),
  parentCommentId: z.string().nullable(),
  author: UserSummarySchema,
  kind: CommentKindSchema,
  body: z.string(),
  status: CommentStatusSchema,
  resolutionNote: z.string().nullable(),
  resolvedBy: z.string().nullable(),
  resolvedAt: z.string().nullable(),
  createdAt: z.string(),
});
export type Comment = z.infer<typeof CommentSchema>;

export interface CommentThread extends Comment {
  replies: Comment[];
}
export const CommentThreadSchema: z.ZodType<CommentThread> = CommentSchema.extend({
  replies: z.array(CommentSchema),
}) as z.ZodType<CommentThread>;

export const CreateCommentInputSchema = z.object({
  body: z.string().min(1).max(10000),
  /** Optional pin to a specific response version number. */
  responseVersion: z.number().int().nullable().optional(),
});
export type CreateCommentInput = z.infer<typeof CreateCommentInputSchema>;

export const ResolveCommentInputSchema = z.object({
  status: z.enum(['resolved', 'rejected', 'open']),
  resolutionNote: z.string().max(2000).optional(),
});
export type ResolveCommentInput = z.infer<typeof ResolveCommentInputSchema>;
